import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { MdError } from "react-icons/md";
import Paths from 'util/paths';
import './PcSuccessNotify.scss';

const ErrorNotify = () => {
    const history = useHistory();

    const handleBack = () => {
        // history.goBack();
				history.push(Paths.purchase.purchasedetails);
    };

    return (
        <div className="error-notification">
            <MdError className='error-icon' />
            <p>お支払いがキャンセルされました。</p>
            <p>ブラウザを閉じて終了してください</p>
            <Button onClick={handleBack}>戻る</Button>
        </div>
    );
};

export default ErrorNotify;
